import { DotProps } from 'recharts';

type Props = DotProps & {
  color: string;
};

export const LineChartDot = ({ color, ...props }: Props) => {
  const { cx, cy, onClick } = props;

  // Early return if cx or cy is undefined
  if (cx === undefined || cy === undefined) {
    return null;
  }

  const handleClick = (event: React.MouseEvent<SVGCircleElement>) => {
    if (onClick) {
      onClick(props, event);
    }
  };

  return (
    <g>
      {/* Invisible larger circle for better click detection - centered exactly on dot */}
      <circle
        cx={cx}
        cy={cy}
        r={15}
        fill="transparent"
        stroke="transparent"
        strokeWidth={0}
        onClick={handleClick}
        style={{ cursor: onClick ? 'pointer' : 'default' }}
        pointerEvents="all"
      />
      {/* Large semi-transparent circle */}
      <circle cx={cx} cy={cy} r={8} fill={color} fillOpacity={0.2} pointerEvents="none" />
      {/* Inner colored circle */}
      <circle cx={cx} cy={cy} r={3.5} stroke="none" fill={color} pointerEvents="none" />
    </g>
  );
};
